module.exports = __webpack_public_path__ + "img/jo.4cc37d8.webp";